import { Typography } from "@altimateai/lego";

interface HeaderProps {
  children: React.ReactNode;
}

const Header = ({ children }: HeaderProps) => (
  <Typography variant="page-heading">
    {children}
  </Typography>
);

export default Header;
